import type { FC } from 'react';
import styled, { useTheme } from 'styled-components';
import { NamedContentEntryText } from '../../../ContentEntryText/NamedContentEntryText';
import { BehaviorType } from '../../enum/BehaviorType';
import { useMediaQuery } from '../../../../lib/hooks/useMediaQuery';

type BehaviorTypeHeaderProps = {
  type: BehaviorType;
};

export const BehaviorTypeHeader: FC<BehaviorTypeHeaderProps> = ({ type }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const theme = useTheme();

  // Match the prototype's legend dots: weak=destructive, neutral=neutral-bar, strong=success.
  const { destructive, neutralBar, success } = theme.colors.prototype;
  const dotColor = type === BehaviorType.WEAK ? destructive : type === BehaviorType.STRONG ? success : neutralBar;

  return (
    <BehaviorTableHeaderContainer type={type}>
      {type !== BehaviorType.STRONG && !isMobile && <Circle $background={dotColor} />}
      {isMobile && <Circle $background={dotColor} />}
      <BehaviorTitle>
        <NamedContentEntryText
          container={'span'}
          refKey="managerTeamBehaviors"
          subKey={
            type === BehaviorType.WEAK
              ? 'weakBehavior'
              : type === BehaviorType.NEUTRAL
                ? 'neutralBehavior'
                : 'strongBehavior'
          }
        />
      </BehaviorTitle>
      {type === BehaviorType.STRONG && !isMobile && <Circle $background={dotColor} />}
    </BehaviorTableHeaderContainer>
  );
};

const BehaviorTableHeaderContainer = styled.div<{ type: BehaviorType }>`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: ${({ type }) => (type === BehaviorType.WEAK ? 'flex-start' : 'flex-end')};
  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

const Circle = styled.div<{ $background: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $background }) => $background};
`;

const BehaviorTitle = styled.div`
  max-width: 180px;
  white-space: wrap;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;
